var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128,
    zoomAndPan: "magnify",
    viewBox: "0 0 96 95.999999",
    height: 128,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    id: "e451f002f3"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    id: "e920144dce"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0.2126 0.7152 0.0722 0 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAAAAACPAi4CAAAAAmJLR0QA/4ePzL8AAAE6SURBVFiF7c87TsNAEMbxL158ArgEcAckLkALnIDQgHmGN7dInfBKeEWiQ6Kg4AhIOUMKKKBL46GA8a6MHe9MhESxU6139/fXGggTJsz/mNro49kFPPTHyK8OiYZ1vV9JiYjStfG8vsBeW6hnnihdl/vE8ZpCQrlpKH2vx29IVP4+Nh1e7/n7DesBcyUuZP4uBtzCvsqLC5t5D5hLQSHzt7HdtIUDlRcUtoo9YC68CtZP5I9s4VDlvQrbfOOmwAPmvKJQ4d3CkcpXFHb47LrUjyx4ecCc8b1jlS8tePuSwi7vdSs9YNp8+0TlCwpC/6vQ4K+OpwdMi80psMzrtvH17huW0Fd4p/CKz+9FK5J4IPr5iw88qXxWeMTMgIiaYg9ETSIaTNcwtTj5/CL3AObm37rvKhkmTJg/mC/FUisBSVBkXAAAAABJRU5ErkJggg==",
    id: "309e503e98",
    height: 64,
    preserveAspectRatio: "xMidYMid meet"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "543f610aaf"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#e451f002f3)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#e920144dce)",
    transform: "matrix(0.75, 0, 0, 0.75, 23.999999, 24.000001)"
  }, /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAAAAACPAi4CAAAAAmJLR0QA/4ePzL8AAAE6SURBVFiF7c87TsNAEMbxL158ArgEcAckLkALnIDQgHmGN7dInfBKeEWiQ6Kg4AhIOUMKKKBL46GA8a6MHe9MhESxU6139/fXGggTJsz/mNro49kFPPTHyK8OiYZ1vV9JiYjStfG8vsBeW6hnnihdl/vE8ZpCQrlpKH2vx29IVP4+Nh1e7/n7DesBcyUuZP4uBtzCvsqLC5t5D5hLQSHzt7HdtIUDlRcUtoo9YC68CtZP5I9s4VDlvQrbfOOmwAPmvKJQ4d3CkcpXFHb47LrUjyx4ecCc8b1jlS8tePuSwi7vdSs9YNp8+0TlCwpC/6vQ4K+OpwdMi80psMzrtvH17huW0Fd4p/CKz+9FK5J4IPr5iw88qXxWeMTMgIiaYg9ETSIaTNcwtTj5/CL3AObm37rvKhkmTJg/mC/FUisBSVBkXAAAAABJRU5ErkJggg==",
    height: 64,
    preserveAspectRatio: "xMidYMid meet"
  })))), /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAIAAAAlC+aJAAAABmJLR0QA/wD/AP+gvaeTAAAD3UlEQVRoge2YPW/bRhjH/w9JmYpENQkyVECGIEBtGUWcwUPyEQIrkDR5kPxl9Dky92Xg5CHt6i/QqYWBNF0d1wWMADasyBWpp8NDMZLMO76IUhrg/oMH6Xz3+/GO99wJMDExMTExMTEx+WpDa+r3VadPIALkDwi/Hv+4joGsdXR60B0QwGAicQCY292jdYxV/gy0e31mzJ78/EAMwi/HP5U7XMkC7V4fLLR3eibIV+U62CX2paOXEMDY3t17/+73sgYtTSBa4hp6iTi0SnMoR+CgcwQwUY4FWZZDCbuQ0M/WeOYwXncGq4++6gzE9ER56Ge637We//XnSvOwkkAqPYMBUOJeR2AQiHd2n71/90dhhuJLqN0bgFKe/T/NhucGqq+JmIjBaPf6hTEKzkC7NwCDkp9tlIum983NeMrk2ZNJ6ChakWxc263nxd7pIjMg9LqXlnDR9NxxcFWvetNJEFp1919l0WSSvoqdNXLPQLvbBwAiHf23njsObqvOb2/enJ6e7j37PgitaiVQzwPEocA85BOI6KPxkjHm6eWzBYfAVi87Yubt1l6ufSmHQCo9gS+ajSV6ycyBqluh1gEAcjlkFTjoHiECV9L/3WxUx5PbamWJXpLFIS7l2R0yCRx0Z/u9okFMP1bQS+YdgjB56Oj+Q7yzu5elPqQLzNEnv7YEvrk635pao/t1Db0kdnArOgciMCOLQ8rx63VnwNExTUdvO9UwGJ+cnOh7i3N4eBiE5Ng8uq1oyhwziPD2+GdNV7oZEProTqjIKD89FudBU+NkHvR7q1Igptcc70dXHwrQS7LVB6lxurN3soDsmARaE70kc40D1A4JArNaq9t1VqeXZHdg2VvvOCwLpNda0OjqzHburU4vWXCYpuyKdx0W/iEP/adS6CWRw5SqTqhyiIGWHD63Tq21a6KXZHcgLNS4qGlqrQVjdP1hTfSSBQdVjcNyjbORodbO6Et4a/X5fNaoKB3i+iAOlFprN0YfJ67TN7cVVRup0wBZHN2IVLfyTdMD8H3fsTkIqe5OWAUW3eNgQVtrPXdSq9/fJL0kdvDcQNOMAEtzLa67kyCkem1rw/SS+XlQtWFiC0k/ijD4xf5OzXvg2Oz7/jo5dRGHmvfgxf5O8lpiSnj8DH6537r8eP30yeMvSC/xff/pk8eXH69f7rfuOjBg8eLWT4DQP3rYGA6HmyNVZzgcPnrYEIelt9WyQ4uYbWYQETGR1fBqZ+eX/x96iTicnV963r3oIyLXdoht6nT6UyKAZ7+OW2+Pf/iCrPq0u9EP2hYRETlJr4CJiYmJiYmJiclXk/8AgodFiZ6OorUAAAAASUVORK5CYII=",
    id: "4840b24cdb",
    height: 64,
    preserveAspectRatio: "xMidYMid meet"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#543f610aaf)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.75, 0, 0, 0.75, 23.999999, 24.000001)"
  }, /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAIAAAAlC+aJAAAABmJLR0QA/wD/AP+gvaeTAAAD3UlEQVRoge2YPW/bRhjH/w9JmYpENQkyVECGIEBtGUWcwUPyEQIrkDR5kPxl9Dky92Xg5CHt6i/QqYWBNF0d1wWMADasyBWpp8NDMZLMO76IUhrg/oMH6Xz3+/GO99wJMDExMTExMTEx+WpDa+r3VadPIALkDwi/Hv+4joGsdXR60B0QwGAicQCY292jdYxV/gy0e31mzJ78/EAMwi/HP5U7XMkC7V4fLLR3eibIV+U62CX2paOXEMDY3t17/+73sgYtTSBa4hp6iTi0SnMoR+CgcwQwUY4FWZZDCbuQ0M/WeOYwXncGq4++6gzE9ER56Ge637We//XnSvOwkkAqPYMBUOJeR2AQiHd2n71/90dhhuJLqN0bgFKe/T/NhucGqq+JmIjBaPf6hTEKzkC7NwCDkp9tlIum983NeMrk2ZNJ6ChakWxc263nxd7pIjMg9LqXlnDR9NxxcFWvetNJEFp1919l0WSSvoqdNXLPQLvbBwAiHf23njsObqvOb2/enJ6e7j37PgitaiVQzwPEocA85BOI6KPxkjHm6eWzBYfAVi87Yubt1l6ufSmHQCo9gS+ajSV6ycyBqluh1gEAcjlkFTjoHiECV9L/3WxUx5PbamWJXpLFIS7l2R0yCRx0Z/u9okFMP1bQS+YdgjB56Oj+Q7yzu5elPqQLzNEnv7YEvrk635pao/t1Db0kdnArOgciMCOLQ8rx63VnwNExTUdvO9UwGJ+cnOh7i3N4eBiE5Ng8uq1oyhwziPD2+GdNV7oZEProTqjIKD89FudBU+NkHvR7q1Igptcc70dXHwrQS7LVB6lxurN3soDsmARaE70kc40D1A4JArNaq9t1VqeXZHdg2VvvOCwLpNda0OjqzHburU4vWXCYpuyKdx0W/iEP/adS6CWRw5SqTqhyiIGWHD63Tq21a6KXZHcgLNS4qGlqrQVjdP1hTfSSBQdVjcNyjbORodbO6Et4a/X5fNaoKB3i+iAOlFprN0YfJ67TN7cVVRup0wBZHN2IVLfyTdMD8H3fsTkIqe5OWAUW3eNgQVtrPXdSq9/fJL0kdvDcQNOMAEtzLa67kyCkem1rw/SS+XlQtWFiC0k/ijD4xf5OzXvg2Oz7/jo5dRGHmvfgxf5O8lpiSnj8DH6537r8eP30yeMvSC/xff/pk8eXH69f7rfuOjBg8eLWT4DQP3rYGA6HmyNVZzgcPnrYEIelt9WyQ4uYbWYQETGR1fBqZ+eX/x96iTicnV963r3oIyLXdoht6nT6UyKAZ7+OW2+Pf/iCrPq0u9EP2hYRETlJr4CJiYmJiYmJiclXk/8AgodFiZ6OorUAAAAASUVORK5CYII=",
    height: 64,
    preserveAspectRatio: "xMidYMid meet"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpMain);
export default __webpack_public_path__ + "static/media/arrow-up-main.6172de5447eb01393e4eedd8fec8e399.svg";
export { ForwardRef as ReactComponent };